export const snackbarClasses = {
  containerRoot: 'notistack-container-root',
};
